export const getFutureMonth = monthsFromNow => {
  const now = new Date();
  const monthIndex = (now.getMonth() + monthsFromNow) % 12;
  return {
    formatted: `${monthIndex + 1}`.padStart(2, '0'),
    index: monthIndex
  };
};
